import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button,
    Paper,
} from '@mui/material';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import { billRecycle, billRestore } from '../../../Services/Services';
import Popover from '@mui/material/Popover';

const BillRestore = () => {
    const [bill, setbill] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [billToDelete, setbillToDelete] = useState(null);

    useEffect(() => {
        const billListApi = async () => {
            try {
                const response = await billRecycle();
                setbill(response);
                console.log("bill fetched successfully:", response);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        billListApi();
    }, []);

    const handleDelete = async (bill_id) => {
        try {
            const response = await billRestore(bill_id);
            setbill(response);
        } catch (error) {
            console.error("Error restoring bill:", error);
        }
    };

    function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
        const date = new Date(dateTimeString);

        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();

        if (format === "dd-mm-yyyy") {
            return `${day}-${month}-${year}`;
        } else if (format === "yyyy-mm-dd") {
            return `${year}-${month}-${day}`;
        } else {
            throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
        }
    }

    const getInitials = (str) => {
        return str
            .split(' ')
            .filter(word => word)
            .map(word => word[0])
            .join('')
            .toUpperCase();
    };

    return (
        <Box>
            {bill.length === 0 ? (
                <Typography>No bill found.</Typography>
            ) : (
                <div id="branch-table-print">
                    <TableContainer
                        component={Paper}
                        sx={{
                            overflowX: "auto",
                            maxWidth: "100%",
                            maxHeight: "90vh", // adjust this value if needed
                        }}
                    >
                        <Table
                            size="small"
                            stickyHeader
                            sx={{
                                "& td, & th": {
                                    borderBottom: "1px solid #ccc",
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow
                                    sx={{
                                        "& th": {
                                            fontWeight: "bold",
                                            color: "#333",
                                            borderBottom: "1px solid #999",
                                            whiteSpace: "nowrap",
                                            backgroundColor: "#f5f5f5",
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 2,
                                        },
                                    }}
                                >
                                    <TableCell>Sr. No.</TableCell>
                                    <TableCell>Ref No</TableCell>
                                    <TableCell>Party Name</TableCell>
                                    <TableCell>Branch Name</TableCell>
                                    <TableCell>LR Id</TableCell>
                                    <TableCell>Bill Date</TableCell>
                                    <TableCell>Total Amt</TableCell>
                                    <TableCell>Rec Amt</TableCell>
                                    <TableCell>Bal Amt</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {bill.map((row, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{
                                            backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                                            "& td": {
                                                paddingTop: "0px",
                                                paddingBottom: "0px",
                                                fontSize: "0.8125rem",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: 120,
                                                color: (theme) =>
                                                    theme.palette.mode === "dark" ? "white" : "inherit",
                                                backgroundColor: (theme) =>
                                                    theme.palette.mode === "dark" ? "black" : "inherit",
                                            },
                                        }}
                                    >
                                        <TableCell>{index + 1}</TableCell>

                                        <TableCell>
                                            {row.branch_name === 'RAIPUR'
                                                ? 'SRE'
                                                : row.branch_name === 'BILASPUR'
                                                    ? 'JHT'
                                                    : 'MBR'
                                            }/{row.billing_id}/{getInitials(row.party_name)}
                                        </TableCell>

                                        <TableCell>{row.party_name}</TableCell>
                                        <TableCell>{row.branch_name}</TableCell>

                                        <TableCell>
                                            {Array.isArray(row.freight_id)
                                                ? row.freight_id.join(", ")
                                                : row.freight_id}
                                        </TableCell>

                                        <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                                        <TableCell>{Number(row.total_amount).toFixed(2)}</TableCell>
                                        <TableCell>{Number(row.paid_amount).toFixed(2)}</TableCell>
                                        <TableCell>{Number(row.rem_amount).toFixed(2)}</TableCell>

                                        <TableCell align="center" className="no-print">
                                            <IconButton
                                                onClick={(e) => {
                                                    setAnchorEl(e.currentTarget);
                                                    setbillToDelete(row.billing_id);
                                                }}
                                                size="small"
                                            >
                                                <RestoreFromTrashIcon
                                                    fontSize="small"
                                                    sx={{ color: "blue" }}
                                                />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )}

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => {
                    setAnchorEl(null);
                    setbillToDelete(null);
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Box sx={{ p: 1 }}>
                    <Typography variant="body2">Are you sure?</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1, gap: 1 }}>
                        <Button
                            color="error"
                            size="small"
                            onClick={async () => {
                                try {
                                    await handleDelete(billToDelete);
                                } finally {
                                    setAnchorEl(null);
                                    setbillToDelete(null);
                                }
                            }}
                        >
                            Yes
                        </Button>

                        <Button
                            size="small"
                            onClick={() => {
                                setAnchorEl(null);
                                setbillToDelete(null);
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </Box>
            </Popover>
        </Box>
    );
};

export default BillRestore;